import React from "react";
import { Button } from "antd";
import CustomButton from "./button";

/**
 * TaskDrawerFooter Component
 * Reusable footer for task drawers with action buttons and metadata display
 *
 * @param {Object} props - Component props
 * @param {Function} props.onSave - Save button click handler
 * @param {Function} props.onCancel - Cancel button click handler
 * @param {Function} props.onDiscardDraft - Discard draft button click handler (optional)
 * @param {boolean} props.showDiscardDraft - Show discard draft button
 * @param {boolean} props.loading - Loading state for save button
 * @param {boolean} props.disabled - Disabled state for save button
 * @param {string} props.saveText - Save button text (default: "Save")
 * @param {string} props.cancelText - Cancel button text (default: "Cancel")
 * @param {string} props.discardDraftText - Discard draft button text (default: "Discard draft")
 * @param {Object} props.metadata - Metadata to display on the right side
 * @param {string} props.metadata.createdBy - Created by name
 * @param {string} props.metadata.completedBy - Completed by name (optional)
 * @param {string} props.metadata.createdByLabel - Created by label text (default: "Created by:")
 * @param {string} props.metadata.completedByLabel - Completed by label text (default: "Completed by")
 */
const TaskDrawerFooter = ({
  onSave,
  onCancel,
  onDiscardDraft,
  showDiscardDraft = false,
  loading = false,
  disabled = false,
  saveText = "Save",
  cancelText = "Cancel",
  discardDraftText = "Discard draft",
  metadata = null,
}) => {
  return (
    <div className="flex-row-centered justify-between">
      <div className="flex-row-centered gap-1">
        <CustomButton
          type="primary"
          btnText={saveText}
          handleClick={onSave}
          loading={loading}
          disabled={disabled}
        />
        <CustomButton btnText={cancelText} handleClick={onCancel} />
        {showDiscardDraft && (
          <Button type="link" onClick={onDiscardDraft}>
            {discardDraftText}
          </Button>
        )}
      </div>
      {metadata && (
        <div className="flex-col-centered gap-1">
          {metadata.completedBy && (
            <span className="flex-row-centered gap-1">
              <span className="xs-400 text-grey-700">
                {metadata.completedByLabel || "Completed by"}
              </span>
              <span className="xs-400 text-grey-500">{metadata.completedBy}</span>
            </span>
          )}
          {metadata.createdBy && (
            <span className="flex-row-centered gap-1">
              <span className="xs-400 text-grey-700">
                {metadata.createdByLabel || "Created by:"}
              </span>
              <span className="xs-400 text-grey-500">{metadata.createdBy}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TaskDrawerFooter;
